import React, { Fragment } from "react";


import { useSelector } from 'react-redux';

//import PropTypes from 'prop-types';

import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";







export default function DataTablePlantaciones() {
    const { plantaciones, allPlantaciones, indexPlantacion } = useSelector( state => state.data);
    //console.log("metricas en DataTable ",rawData);

    const data = [];
    if (allPlantaciones){
        plantaciones.map((row) => {
            data.push([row.nombre, row.tipo, row.descripcion,  row.ubicacion.lat.toFixed(4),  row.ubicacion.lng.toFixed(4), 
                <div key={indexPlantacion} style={{ display: "flex",  width: "20px", height: "20px", backgroundColor: row.color, borderRadius: "50%"  }}></div> 
            ])
        });
    }else{
        data.push([<div key={indexPlantacion} style={{fontWeight: "600"}}>{plantaciones[indexPlantacion].nombre}</div>, plantaciones[indexPlantacion].tipo, plantaciones[indexPlantacion].descripcion,  plantaciones[indexPlantacion].ubicacion.lat.toFixed(4), plantaciones[indexPlantacion].ubicacion.lng.toFixed(4), 
          <div key={indexPlantacion} style={{ display: "flex",  width: "20px", height: "20px", backgroundColor: plantaciones[indexPlantacion].color, borderRadius: "50%"  }}></div> 
        ])  
    }
    

    return(
        <Fragment>
            
                {/* <div style={{fontWeight: "600", fontSize: "10pt"}}>
                    <h6>
                        Plantaciones:
                    </h6>
                </div> */}
                
                { (allPlantaciones) ? 
                    plantaciones.map((row) => {
                            return (
                                <div style={{display: "flex", padding:'5px'}} key={row.nombre}>
                                    <div style={{ marginLeft: "5px", width: "20px", height: "20px", backgroundColor: row.color, borderRadius: "50%"  }}></div>
                                    <div style={{display: "inline", fontWeight: "600", marginLeft: "5px"}}>{row.nombre}</div>
                                    <div style={{display: "inline", fontWeight: "400", marginLeft: "10px"}}>{row.descripcion}</div>
                                </div>
                            )  
                    })
                    
                :
                    <div style={{display: "flex", padding:'5px'}} key={plantaciones[indexPlantacion].nombre}>
                        <div style={{ marginLeft: "5px", width: "20px", height: "20px", backgroundColor: plantaciones[indexPlantacion].color, borderRadius: "50%"  }}></div>
                        <div style={{display: "inline", fontWeight: "600", marginLeft: "5px"}}>{plantaciones[indexPlantacion].nombre}</div>
                        <div style={{display: "inline", fontWeight: "400", marginLeft: "10px"}}>{plantaciones[indexPlantacion].descripcion}</div>
                    </div>
                }

                
                
                
                
             

        </Fragment>
        
    )
}



